export function getRampValue<T>(
  data: Record<number, T>,
  key: number
): T | null {
  let result = null;
  for (let i = key; i > 0; i--) {
    result = data[i];
    if (result != null) {
      break;
    }
  }
  return result;
}

export function getRampKey(data: Record<number, any>, key: number): number {
  let result = null;
  for (let i = key; i > 0; i--) {
    result = data[i];
    if (result != null) {
      return i;
    }
  }
  return 0;
}
